<router-outlet></router-outlet>
<ngx-spinner
bdColor="#ffffff"
size="large"
color="#fff"
type="pacman"
fullScreen="true">
<p style="font-size: 20px; color: white" i18n="Please Wait |@@pleaseWait">Please Wait...</p>
</ngx-spinner>
<app-version-update-notification></app-version-update-notification>
